import { useState, useEffect } from "react"
import { createPortal } from "react-dom"
import {
  encryptUsername,
  decryptUsername,
  encryptPassword,
  decryptPassword,
} from "./GlobalContext"
import LoginToPlay from "./LoginToPlay"
import Register from "./Register"
import ModulesLotteryDraw from "../promotions/promotion_modules/modules_lotterDraw"
const dataUrl = process.env.REACT_APP_DATA_JSON_URL

export default function LoginGlobal({
  label = "Login / Register",
  btnClass = "header-login-btn fgh-normal-button fgh-log-btn",
  children,
}) {
  // Initialize login values from localStorage.
  // For username, we decrypt it.
  const initialRememberMe = localStorage.getItem("rememberMe") === "true"
  const initialUsername = localStorage.getItem("username")
    ? decryptUsername(localStorage.getItem("username"))
    : ""
  const initialPassword = initialRememberMe
    ? localStorage.getItem("password")
      ? decryptPassword(localStorage.getItem("password"))
      : ""
    : ""

  const [user, setUser] = useState({
    username: initialUsername,
    password: initialPassword,
  })
  const [rememberMe, setRememberMe] = useState(initialRememberMe)
  const [showPassword, setShowPassword] = useState(false)
  const [login, setLogin] = useState(false)

  // Maintain local login state (isLoggedIn)
  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem("isLoggedIn") === "true"
  )

  const [ui, setUI] = useState({
    errorMessage: "",
    isLoginModalOpen: false,
    isDropdownOpen: false,
    dropdownTimer: null,
    loadingBalance: false,
    processingLogin: false,
  })
  const [isShowLogin, setIsShowLogin] = useState(true)
  const [isShowForgotPass, setIsShowForgotPass] = useState(false)
  const [isShowRegister, setIsShowRegister] = useState(false)
  const [activeModal, setActiveModal] = useState(null)
  const [phoneNo, setPhoneNo] = useState("")
  const [otpSent, setOtpSent] = useState(false)
  const [alertMsg, setAlertMsg] = useState("")
  const [successAlertMsg, setSuccessAlertMsg] = useState("")

  // These states are added for changing password.
  const [otp, setOtp] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [passwordChanged, setPasswordChanged] = useState(false)

  // Automatically open login modal if "ag" query param is present
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)
    if (
      queryParams.get("ag") === "ANM001" ||
      queryParams.get("ag") === "ANOBA" ||
      queryParams.get("ag") === "ANOBAF" ||
      queryParams.get("ag") === "ANA00"
    ) {
      // Show the login modal
      setUI((prev) => ({ ...prev, isLoginModalOpen: true }))

      // Instead of Login, show Register form directly
      setIsShowLogin(false)
      setIsShowRegister(true)
    }
  }, [])

  // Referral handling
  useEffect(() => {
    const referrer = document.referrer
    const currentHost = window.location.host
    const urlParams = new URLSearchParams(window.location.search)
    const fromParam = urlParams.get("from")

    const getCoreDomain = (url) => {
      try {
        const hostname = new URL(url).hostname.replace(/^www\./, "")
        const parts = hostname.split(".")
        if (parts.length >= 2) {
          return parts[parts.length - 2]
        }
        return hostname
      } catch (e) {
        return null
      }
    }

    const isExternalReferrer =
      referrer && !referrer.includes(currentHost) && !fromParam

    if (isExternalReferrer) {
      const coreDomain = getCoreDomain(referrer)
      if (coreDomain) {
        const newUrl = `${window.location.origin}${window.location.pathname}?from=${coreDomain}`
        window.location.replace(newUrl)
      }
    }

    if (fromParam) {
      setUI((prev) => ({ ...prev, isLoginModalOpen: true }))
      setIsShowLogin(false)
      setIsShowRegister(true)
    }
  }, [])

  const modalComponents = {
    "2/30 Lottery Draw": ModulesLotteryDraw,
  }
  const ActiveModal = activeModal ? modalComponents[activeModal] : null

  // useEffect(() => {
  //   if (isLoggedIn && !sessionStorage.getItem("lotteryModalShown")) {
  //     setActiveModal("2/30 Lottery Draw")
  //     sessionStorage.setItem("lotteryModalShown", "true")
  //   }
  // }, [isLoggedIn])

  // Detect mobile view (width ≤ 1024px)
  const [mobileView, setMobileView] = useState(
    () => window.matchMedia("(max-width: 1024px)").matches
  )
  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 1024px)")
    const handleChange = (e) => setMobileView(e.matches)
    mediaQuery.addEventListener("change", handleChange)
    return () => {
      mediaQuery.removeEventListener("change", handleChange)
    }
  }, [])

  const HandleOpenRegister = () => {
    setIsShowLogin(false)
    setIsShowRegister(true)
  }

  const handleOpenForgotPass = () => {
    setIsShowLogin(false)
    setIsShowForgotPass(true)
  }

  const handleBackBtn = () => {
    setIsShowForgotPass(false)
    setIsShowLogin(true)
    setOtpSent(false)
    setPasswordChanged(false)
    setPhoneNo("")
  }

  useEffect(() => {
    if (ui.errorMessage) {
      const timer = setTimeout(() => {
        setUI((prev) => ({ ...prev, errorMessage: "" }))
      }, 10000)
      return () => clearTimeout(timer)
    }
  }, [ui.errorMessage])

  // Prevent background scrolling when modal is open
  useEffect(() => {
    document.body.style.overflow = ui.isLoginModalOpen ? "hidden" : ""
  }, [ui.isLoginModalOpen])

  // Redirect from protected pages if not logged in
  useEffect(() => {
    const protectedPaths = ["/profile"]
    if (protectedPaths.includes(window.location.pathname) && !isLoggedIn) {
      window.location.href = "/"
    }
  }, [isLoggedIn])

  // When logged in, update localStorage.
  // Here we store the username in encrypted form.
  useEffect(() => {
    if (isLoggedIn) {
      localStorage.setItem("isLoggedIn", "true")
      localStorage.setItem("username", encryptUsername(user.username))
      if (rememberMe) {
        localStorage.setItem("password", encryptPassword(user.password))
        localStorage.setItem("rememberMe", "true")
      } else {
        localStorage.removeItem("password")
        localStorage.setItem("rememberMe", "false")
      }
    } else {
      localStorage.removeItem("isLoggedIn")
      if (!rememberMe) {
        localStorage.removeItem("username")
        localStorage.removeItem("password")
      }
    }
    document.body.classList.toggle("IsLoggedIn", isLoggedIn)
  }, [isLoggedIn, user.username, user.password, rememberMe])

  const handleResponse = (data) => {
    if (data.s === "success") {
      setUser((prev) => ({
        ...prev,
        username: data.username,
        password: rememberMe ? prev.password : "",
      }))
      localStorage.setItem("sessionId", data.session)
      setIsLoggedIn(true)
      setUI((prev) => ({ ...prev, errorMessage: "", isLoginModalOpen: false }))
      updateAPILoginState(true)

      window.location.reload()
    } else {
      setUI((prev) => ({
        ...prev,
        errorMessage: data.emsg || "Login failed. Please try again.",
      }))
    }
  }

  const handleLogin = async (e) => {
    e.preventDefault()
    setUI((prev) => ({ ...prev, processingLogin: true }))
    try {
      const response = await fetch(dataUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          cmd: "loginjs",
          u: user.username,
          p: user.password,
        }),
      })
      if (!response.ok) throw new Error("Network response was not ok.")
      const data = await response.json()
      handleResponse(data)
    } catch (error) {
      setUI((prev) => ({
        ...prev,
        errorMessage: "Login failed. Please try again.",
      }))
    } finally {
      setUI((prev) => ({ ...prev, processingLogin: false }))
    }
  }

  const updateAPILoginState = (loggedIn) => {
    fetch(dataUrl, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        cmd: "updateLoginState",
        username: user.username,
        isLoggedIn: loggedIn,
      }),
    }).catch(console.error)
  }

  const toggleLoginModal = () => {
    if (ui.isLoginModalOpen) {
      setIsShowLogin(true)
      setIsShowForgotPass(false)
      setIsShowRegister(false)
      if (!rememberMe) {
        setUser({ username: "", password: "" })
      }
      setUI((prev) => ({ ...prev, errorMessage: "" }))
    }
    setUI((prev) => ({ ...prev, isLoginModalOpen: !prev.isLoginModalOpen }))
  }

  const { processingLogin, errorMessage, isLoginModalOpen, isDropdownOpen } = ui

  const handleGetOTP = async (e) => {
    e.preventDefault()
    let message = `OTP sent to [${phoneNo}]`

    // Validate phone number: Must be 11 characters and start with "0"
    if (phoneNo.length !== 11 || !phoneNo.startsWith("0")) {
      message = "Invalid Phone Number"
      setAlertMsg(message)
      return
    }

    // Create form data; this replicates the serialize() method
    const formData = new URLSearchParams()
    // You can append additional form fields if needed.
    formData.append("mobile", phoneNo)
    formData.append("cmd", "getOTP")

    try {
      const response = await fetch(dataUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: formData.toString(),
      })

      const data = await response.json()

      if (data.s === true) {
        setAlertMsg(message)
        setOtpSent(true)
      } else {
        message = "Invalid Phone Number"
        if (data.emsg) {
          message = data.emsg
        }
        setAlertMsg(message)
      }
    } catch (error) {
      console.error("Error fetching OTP:", error)
      setAlertMsg("An error occurred. Please try again.")
    }
  }

  const handleChangePass = async (e) => {
    e.preventDefault()
    // Ensure the new password and confirmation match
    if (newPassword !== confirmPassword) {
      setAlertMsg("Passwords do not match.")
      return
    }

    const formData = new URLSearchParams()
    formData.append("mobile", phoneNo)
    formData.append("cmd", "changepasswordWithOTP")
    formData.append("otp", otp)
    formData.append("password", newPassword)
    formData.append("confirmpassword", confirmPassword)

    try {
      const response = await fetch(dataUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: formData.toString(),
      })

      const data = await response.json()

      if (data.s) {
        setSuccessAlertMsg(data.s)
        // Clear the inputs once successful
        setOtp("")
        setNewPassword("")
        setConfirmPassword("")
        setAlertMsg("")
        setPasswordChanged(true)
      } else {
        setAlertMsg(data.e || "Password change failed. Please try again.")
      }
    } catch (error) {
      console.error("Error changing password:", error)
      setAlertMsg("An error occurred. Please try again.")
    }
  }

  const showLogin = () => {
    setLogin(true)
  }
  return (
    <>
      {login &&
        createPortal(
          <LoginToPlay onClose={() => setLogin(false)} />,
          document.body
        )}
      {!isLoggedIn && (
        <>
          <div className="header-nav-buttons">
            <button onClick={showLogin} className={btnClass}>
              {label}
            </button>
          </div>

          {isLoginModalOpen && (
            <div className="fgh-login-modal">
              <div className="fgh-login-modal-content">
                <button
                  className="fgh-login-modal-close-btn"
                  onClick={toggleLoginModal}
                >
                  <img src="/images/icon/close-btn.webp" alt="Close" />
                </button>
                <div className="fgh-login-form-container">
                  <div className="fgh-login-banner">
                    <img
                      src="/images/fun-hub-gaming-login.webp"
                      alt="fun gaming hub fgh"
                    />
                  </div>
                  <div className="fgh-login-container">
                    <img
                      src="/images/icon/fgh-logo.webp"
                      alt="fgh logo"
                      className="login-logo"
                    />
                    {isShowLogin && (
                      <div className="fgh-login-module">
                        <form
                          className="fgh-form-login"
                          onSubmit={handleLogin}
                          autoComplete="off"
                        >
                          <h2 className="fgh-login-reg">
                            Sign into your account
                          </h2>
                          <input
                            type="text"
                            value={user.username}
                            onChange={(e) =>
                              setUser({ ...user, username: e.target.value })
                            }
                            placeholder="Username / Phone"
                            required
                            className="fgh-form-input fgh-input-username"
                          />
                          <div
                            className="fgh-input-password-field"
                            style={{ position: "relative" }}
                          >
                            <input
                              type={showPassword ? "text" : "password"}
                              value={user.password}
                              onChange={(e) =>
                                setUser({ ...user, password: e.target.value })
                              }
                              placeholder="Password"
                              required
                              className="fgh-form-input"
                            />
                            <button
                              type="button"
                              onClick={() => setShowPassword(!showPassword)}
                              className="fgh-password-btn"
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                              }}
                            >
                              {showPassword ? (
                                <img
                                  src="/images/icon/hide-password.webp"
                                  alt="Hide Password"
                                  className="password-icon-status"
                                />
                              ) : (
                                <img
                                  src="/images/icon/reveal-password.webp"
                                  alt="Show Password"
                                  className="password-icon-status"
                                />
                              )}
                            </button>
                          </div>
                          <div className="forgot-password-remember-me-container">
                            {/* <div className="login-remember-me-container">
                                <input
                                  type="checkbox"
                                  className="label-remember-me-checkbox"
                                  id="label-remember-me-checkbox"
                                  checked={rememberMe}
                                  onChange={() => setRememberMe(!rememberMe)}
                                />
                                <label htmlFor="label-remember-me-checkbox">
                                  Remember Me
                                </label>
                              </div> */}
                            <span
                              className="forgot-password-link"
                              onClick={handleOpenForgotPass}
                            >
                              Forgot Password?
                            </span>
                          </div>

                          <button
                            type="submit"
                            className={`fgh-form-login-btn fgh-normal-button ${
                              user.username.trim() === "" ||
                              user.password.trim() === ""
                                ? "disabled"
                                : ""
                            }`}
                            disabled={
                              user.username.trim() === "" ||
                              user.password.trim() === ""
                            }
                          >
                            {processingLogin ? "Processing ..." : "Login"}
                          </button>
                        </form>
                        <button
                          className="fgh-register-btn"
                          onClick={HandleOpenRegister}
                        >
                          Register Now
                        </button>
                        {errorMessage && (
                          <div className="error-popup">{errorMessage}</div>
                        )}
                      </div>
                    )}
                    {isShowForgotPass && (
                      <div className="fgh-forgot-password-module">
                        {!otpSent ? (
                          <form
                            className="fgh-forgot-password"
                            autoComplete="off"
                            onSubmit={handleGetOTP}
                          >
                            <h2>Forgot Password</h2>
                            <input
                              type="text"
                              placeholder="Example: 09123456789"
                              className="fgh-form-input"
                              id="mobile"
                              value={phoneNo}
                              onChange={(e) => {
                                const value = e.target.value
                                if (/^\d*$/.test(value)) {
                                  setPhoneNo(value)
                                }
                              }}
                              inputMode="numeric"
                              maxLength={11}
                            />
                            <input name="otp" type="hidden" value="" />
                            <input name="password" type="hidden" value="" />
                            <input
                              name="confirmpassword"
                              type="hidden"
                              value=""
                            />
                            <div className="fgh-forgot-pass-btn">
                              <button
                                className={`fgh-normal-button get-otp-btn ${
                                  phoneNo.trim() === "" ? "disabled" : ""
                                }`}
                              >
                                Get OTP
                              </button>
                              <button
                                className={`fgh-back-to-login`}
                                onClick={handleBackBtn}
                              >
                                Back to Login
                              </button>
                            </div>
                          </form>
                        ) : (
                          <div id="forgotpassword-2">
                            <div className="fgh-forgot-password-module">
                              <form
                                autoComplete="off"
                                className="fgh-change-password"
                                onSubmit={handleChangePass}
                              >
                                <h2>Change Password</h2>
                                {alertMsg && (
                                  <div id="otpAlert">
                                    <p>{alertMsg}</p>
                                  </div>
                                )}
                                <input
                                  name="mobile"
                                  type="hidden"
                                  className="fgh-form-input"
                                  autoComplete="off"
                                  value={phoneNo}
                                />
                                <input
                                  name="otp"
                                  type="number"
                                  value={otp}
                                  onChange={(e) => setOtp(e.target.value)}
                                  inputMode="numeric"
                                  className="fgh-form-input"
                                  placeholder="OTP Pin"
                                  autoComplete="off"
                                  disabled={passwordChanged}
                                />
                                <input
                                  name="password"
                                  type="password"
                                  value={newPassword}
                                  onChange={(e) =>
                                    setNewPassword(e.target.value)
                                  }
                                  className="fgh-form-input"
                                  placeholder="New Password"
                                  autoComplete="off"
                                  disabled={passwordChanged}
                                />
                                <input
                                  name="confirmpassword"
                                  type="password"
                                  value={confirmPassword}
                                  onChange={(e) =>
                                    setConfirmPassword(e.target.value)
                                  }
                                  className="fgh-form-input"
                                  placeholder="Confirm New Password"
                                  autoComplete="off"
                                  disabled={passwordChanged}
                                />
                                {successAlertMsg && (
                                  <div id="otpAlert" className="changed-pass">
                                    <p>{successAlertMsg}</p>
                                  </div>
                                )}
                                <div className="fgh-forgot-pass-btn">
                                  {!passwordChanged && (
                                    <button
                                      className={`fgh-normal-button change-password-btn ${
                                        newPassword.trim() === "" ||
                                        confirmPassword.trim() === "" ||
                                        otp.trim() === ""
                                          ? "disabled"
                                          : ""
                                      }`}
                                    >
                                      Change Password
                                    </button>
                                  )}
                                  {passwordChanged && (
                                    <button
                                      className="fgh-normal-button"
                                      onClick={handleBackBtn}
                                    >
                                      Back to Login
                                    </button>
                                  )}
                                </div>
                              </form>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {isShowRegister && (
                      <Register
                        onOpenLogin={() => {
                          setIsShowLogin(true)
                          setIsShowRegister(false)
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  )
}
